module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALJJREFUeNpiYKAGUFRUnM+CR1IASM0HYgEWPAr2A7EBEDsyEVAw4f79+weY8Ci4AMSNIHEmJAUGSAo+AHEi0BQQzcAIVRAAcyRUgSNQwQWYAYxQBeuRbDVEVgCz7gAUw0A+umcYkQMNSCVAuQuApiXC5JhhjA8fPmwUFBT8CGR6gBwPZAsAxXaiKIIqPAGUfAhkgtxpAWIDxS4w4ghxWHCAPcKIJ+5gCg8wEkgBYIUAAQYAU5c77boa5LQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/prev-active.png
// module id = 266
// module chunks = 0